import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CancelSubscriptionDialogComponent } from './cancel-subscription-dialog.component';

@NgModule({
  declarations: [CancelSubscriptionDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [CancelSubscriptionDialogComponent],
  entryComponents: [CancelSubscriptionDialogComponent],
})
export class CancelSubscriptionDialogModule {}
